import useApi from "@/hooks/useApi.ts";
import {Channel, ChannelUp, ChannelUpdateUp} from "@/types/Channel.ts";

type UseChannelApiHook = {
    token?: string
    getChannels: () => Promise<Channel[]>
    getChannel: (id: string) => Promise<Channel>;
    registerChannel: (data: ChannelUp) => Promise<void>;
    updateChannel:(data:ChannelUpdateUp) => Promise<void>;
    deleteChannel:(id:string) => Promise<void>;
}

const useChannelApi = (): UseChannelApiHook => {
    const {token, apiPost, apiGet, apiPut,apiDelete} = useApi();

    const getChannels = (): Promise<Channel[]> => {
        return apiGet<Channel[]>("/channels" )
    }

    const registerChannel = (data: ChannelUp): Promise<void> => {
        return apiPost<ChannelUp, void>("/channels", data)
    }

    const updateChannel = (data: ChannelUpdateUp): Promise<void> => {
        return apiPut<ChannelUpdateUp, void>(`/channels`, data)//{id, data}
    }

    const deleteChannel = (id:string): Promise<void> => {
        return apiDelete<void>(`/channels/${id}`)
    }

    const getChannel = (id: string): Promise<Channel> => {
        return apiGet<Channel>(`/channels/${id}`)
    }

    return {
        token,
        getChannels,
        getChannel,
        registerChannel,
        updateChannel,
        deleteChannel,
    };
};

export default useChannelApi